import { Plug, Check } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { CaptureButton } from "@/components/PageHeader";
import { integrations } from "@/lib/data/extras";

export default function Integraciones() {
  return (
    <div className="h-full overflow-y-auto scrollbar-thin" data-testid="integrations-page">
      <div className="px-4 md:px-8 py-6 md:py-8 max-w-5xl mx-auto space-y-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="font-serif text-3xl tracking-tight">Integraciones</h1>
            <p className="mt-1.5 text-muted-foreground text-[15px]">
              Conecta Aviando con tus herramientas para que el conocimiento fluya hacia donde trabajas.
            </p>
          </div>
          <CaptureButton />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
          {integrations.map((i) => (
            <div key={i.id} className="rounded-lg border bg-card p-4 flex flex-col hover:border-teal-300/60 transition-colors" data-testid={`integration-card-${i.id}`}>
              <div className="flex items-center gap-2.5">
                <span className="w-10 h-10 rounded-lg border bg-secondary grid place-items-center shrink-0">
                  <Plug className="h-4.5 w-4.5 h-[18px] w-[18px] text-muted-foreground" strokeWidth={1.75} />
                </span>
                <span className="font-medium flex-1">{i.name}</span>
                {i.connected && (
                  <span className="flex items-center gap-1 text-[13px] text-green-700 dark:text-green-400 font-medium">
                    <Check className="h-3.5 w-3.5" strokeWidth={2} /> Conectado
                  </span>
                )}
              </div>
              <p className="mt-2.5 text-sm text-muted-foreground flex-1">{i.desc}</p>
              <Button
                variant={i.connected ? "outline" : "default"}
                size="sm"
                className="mt-3 self-start"
                onClick={() => toast(i.connected ? `Configuración de ${i.name} en la versión final.` : `Conexión con ${i.name} en la versión final.`)}
              >
                {i.connected ? "Configurar" : "Conectar"}
              </Button>
            </div>
          ))}
        </div>

        <p className="text-[13px] text-muted-foreground">
          ¿Echas de menos alguna herramienta?{" "}
          <button type="button" onClick={() => toast("¡Gracias! Lo anotamos.")} className="text-primary hover:underline">
            Pídenosla →
          </button>
        </p>
      </div>
    </div>
  );
}
